module.exports = __webpack_public_path__ + "assets/0faac01953c1f99dc6b3f57ca19b0919.png";